import { supabase } from '../../../../lib/supabase'
import { reportUnexpectedError } from '../../../../lib/reportError'

function isLocalUri(uri: string) {
  return uri.startsWith('blob:') || uri.startsWith('data:')
}

async function uploadRewardItemImage(rewardItemId: string, localUri: string): Promise<string> {
  // Reading back the local image-picker URI is a purely client-side step —
  // no backend round trip — so a failure here is invisible anywhere else.
  let blob: Blob
  try {
    const response = await fetch(localUri)
    blob = await response.blob()
  } catch (err) {
    reportUnexpectedError(err)
    throw err
  }

  const extension = blob.type.split('/')[1] ?? 'jpg'
  const path = `${rewardItemId}/${Date.now()}.${extension}`

  const { error } = await supabase.storage
    .from('reward-items')
    .upload(path, blob, { contentType: blob.type, upsert: true })
  if (error) throw error

  return supabase.storage.from('reward-items').getPublicUrl(path).data.publicUrl
}

export async function resolveRewardItemImageUrl(rewardItemId: string, imageUri: string | null): Promise<string | null> {
  if (imageUri && isLocalUri(imageUri)) {
    return uploadRewardItemImage(rewardItemId, imageUri)
  }
  return imageUri
}
